module.exports = __webpack_public_path__ + "static/media/fly0084.1e86bfaf.webp";